module.exports = "<section   class=\"ac-container\">\n  <div *ngFor=\"let item of data.rules; let i = index;\">\n    <input [attr.id]=\"i\" name=\"accordion-1\" type=\"radio\" />\n    <div class=\"rules-label\">\n      <label [attr.for]=\"i\" [innerHTML]=\"item.title | safeHtml\"></label>\n    </div>\n    <article [innerHTML]=\"item.description | safeHtml\">\n    </article>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/src/app/rules/rules.component.html
// module id = ../../../../../src/app/rules/rules.component.html
// module chunks = 0